<template>
  <div id="stat-view">
    <!-- Vuetify を使っていないことを忘れずに！ -->

    <transition name="fade">
      <div id="loading" v-show="process">
        <Loading />
      </div>
    </transition>

    <transition name="fade">
      <div><!-- <transition> can only be used on a single element により div で囲む -->
        <div id="shop-info">
          <b v-text="selectedShopName" class="shopname"></b>
          <b v-text="today" id="today"></b>
        </div>

        <div v-show="!process">
          <div v-if="closed && !list.length" id="closed">
            <h1 class="msg">ただいま営業時間外です。</h1>
            <i class="img"></i>
          </div>
          <div v-else-if="!response.state.restSchedules.length" id="closed-day">
            <h1 class="msg">本日は休業日です。</h1>
            <i class="img"></i>
          </div>
          <div v-else-if="!receptable && !list.length" id="unreceptable">
            <h1 class="msg">本日の受付は終了しました。</h1>
            <i class="img"></i>
          </div>

          <div v-else-if="error">
            <h1>システム障害が発生しております。。</h1>
            <h2>復旧するまでお待ちください。</h2>
          </div>

          <div v-else-if="prepared">
            <div v-if="message" class="-message" v-text="message"></div>
            <div v-if="list.length > 0">
              <div id="heading" class="XXXflex">
                <!-- <div v-if="waitingTime" class="-waiting">
                  <div class="-above">ただいま</div>
                  <span class="-count" v-text="waitingCount"></span>人
                  <span class="-time">{{waitingTime | minuteStr}}</span>
                  <div class="-below">待ちです</div>
                </div>
                <div v-else class="-waiting">
                  <div class="-above">本日は</div>
                  <span class="-time">受付終了</span>
                  <div class="-below">となりました</div>
                </div> -->

                <div class="-info flex">
                  <div class="-waiting">
                    <div v-if="waitingTime > -1">
                      <div>
                        <span class="-count">{{waitingCount}}人待ち</span>
                      </div>
                      <div>
                        <span v-if="waitingTime" class="-time">{{waitingTime | minuteStr}}待ち</span>
                        <span v-else class="-time">待ち時間なし</span>
                      </div>
                    </div>
                    <div v-else class="-count-over">
                      <p>受付終了</p>
                      <p>受入れ上限数を超えたため、<br>本日の受付は終了しました。</p>
                    </div>
                  </div>

                  <div @click="loadData" @touchstart="loadData" class="-tips flex">
                    <span class="-reload">
                      <i class="-icon icon-reload"></i>
                    </span>
                    
                    <div class="-desc">
                      <span>
                        <i class="-icon icon-waiting"></i>
                        <span class="-text">待ち</span>
                      </span>
                      <span class="-ope">
                        <i class="-icon icon-operating"></i>
                        <span class="-text">実施中</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <table v-show="list.length > 0">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>予定時刻</th>
                    <th>お名前</th>
                    <th>状態</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,i) in list" :key="`stat-${i}`"
                    :class="{'-operating': item.ope_from, '-waiting': !item.ope_from}"
                  >
                    <th class="-num" v-text="item.num"></th>
                    <td class="-time">
                      {{item.time_from|formatTime}}
                    </td>
                    <td class="-name">
                      <span :class="{'-reserve':item.reserved}"></span>
                      <span class="-text" v-text="name(item)"></span>
                    </td>
                    <td class="-stat">
                      <!-- <span class="-text" v-text="stat(item)"></span> -->
                      <i class="-ope -icon icon-operating" v-if="item.ope_from"></i>
                      <i class="-wait -icon icon-waiting" v-else></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else>
              <h1 class="-message">待ち時間なし</h1>
              <p class="-desc">
                ただいまのお時間はすぐにご対応いたします。
              </p>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Loading from '@/components/Loading'

export default {
  components: {
    Loading,
  },
  data() {
    return {
      response: {
        // list // 予約・受付一覧
        // receptable // 今から受付したら閉店時間を過ぎるかどうか
        // opening // 営業時間外か？
        // state as {menus, setting, restSchedules}
      },
      messageData: {},
      error: null,
      process: 1,
      interval: null,
      // 予約データの場合に何分先までをリストに出すか
      reserved_display_within: 30,
    }
  },
  computed: {
    ...mapGetters("shop", ["selectedShopId", "selectedShopName"]),
    prepared() {
      return !this.process && this.response.state && this.response.state.setting
    },
    // 一覧リスト: reception :: getter :: displayDatas と同じロジックを使うこと！
    list() {
      const list = this.response.list || [];
      const now = new Date();
      const nowHHMM = this.dateToHHMM(now);
      // 今から reserved_display_within 分後のHHMM
      const reservedWithin = this.dateToHHMM(
        new Date(now.getTime() + this.reserved_display_within * 60000)
      );

      // 予約を除いた受付データの最後尾の開始時間を求める
      const lastData = list
      .filter(data => !data.reserved)
      .reduce((a,b) => {
        const aFrom = a.ope_from ? this.dateToHHMM(a.ope_from) : a.time_from;
        const bFrom = b.ope_from ? this.dateToHHMM(b.ope_from) : b.time_from;
        return aFrom > bFrom ? a : b
      }, {time_from:nowHHMM});
      
      // 受付最後の開始時刻＋reserved_display_within分を求める
      let lastTimeFrom = lastData.ope_from ? this.dateToHHMM(lastData.ope_from) : lastData.time_from;
      lastTimeFrom = this.dateToHHMM(
        this.hhmmToDate(lastTimeFrom).getTime() + this.reserved_display_within * 60000
      );

      return list
      // 施術予定順にする
      .sort((a,b) => a.time_from > b.time_from ? a : b)
      // 予約で未実施の場合は、最終受付開始時間＋以内、または、現在時刻＋30分以内のみリストにあげる
      .filter(data => {
        //予約で未実施の場合は検査する
        if (data.reserved && !data.ope_from) {
          // 今から reservedWithin 分以内、または、受付最後の開始時刻＋reserved_display_within 分以内
          return data.time_from <= reservedWithin || data.time_from <= lastTimeFrom;
        }
        
        // 受付データは必ず表示する
        return true;
      });
    },
    closed() {
      return !this.response.opening;
    },
    receptable() {
      return this.response.receptable;
    },
    waitingCount() {
      // 受付不可能なら予約数をそのまま返す
      if (this.waitingTime < 0) {
        return this.list.length
      }
      // // 待機時間以内に開始する予約数を返す
      const now = this.dateToHHMM(new Date());
      const time = this.addMin(now, this.waitingTime);
      return this.list.filter(r => !r.ope_from && r.time_from <= time).length;
    },
    waitingTime() {
      const menu = this.response.state.menus.find(m => m.how_to_use == 22);
      const assigns = ailabot.reception.assignReception(this.response.state, menu.span);

      // assigns.length == 0 == 満員の場合は受付終了
      if (!assigns.length) {
        return -1
      }

      // 最速で受付可能なものを探す
      const minHHMM = assigns
      .map(a => a.timeFrom)
      .reduce((a,b) => a < b ? a : b, this.response.state.setting.open_time_to);

      // ↑は今から何分後か？
      const now = new Date();
      const waitTime = this.hhmmToDate(minHHMM);
      const diffTime = waitTime.getTime() - now.getTime();
      const diffMinutes = Math.floor(diffTime / (1000*60));

      return Math.max(0, diffMinutes);
    },
    message() {
      return this.messageData.message || "";
    },
    today() {
      const date = new Date();
      const dateNames = ['日', '月', '火', '水', '木', '金', '土'];
      return `${date.getMonth() +1}月 ${date.getDate()}日 (${dateNames[date.getDay()]})`
    }
  },
  methods: {
    dateToHHMM(date) {
      if (typeof date != 'object') {
        date = new Date(date);
      }
      return Number(`${date.getHours()}${('00' + (date.getMinutes())).slice(-2)}`)
    },
    hhmmToDate(hhmm) {
      const dt = new Date();
      dt.setHours(Math.floor(hhmm/100));
      dt.setMinutes(Number(String(hhmm).substr(-2)));
      return dt;
    },
    // reception :: time.js から拝借:
    // hhmm に minutes分を加算した hhmm を返す
    // addMin(1830, 60): (30+60)/60=1.5; hh=18+1of1.5=19; mm=0.5in1.5*60=30
    addMin(hhmm, minutes) {
      const dec = (hhmm%100 + minutes) /60;
      return (Math.floor(hhmm/100) + Math.floor(dec)) *100 + (dec-Math.floor(dec))*60;
    },
    async loadData() {
      this.process = 1;
      const response = {};

      try {
        // 予約・受付の一覧、営業情報
        let res = await fetch(
          process.env.VUE_APP_API_SERVER + `stat/${this.selectedShopId}`, {credentials: "include"}
        );
        res = await res.json();
        response.list = res.list;
        // res.receptable: 今から受付したら閉店時間を過ぎるかどうか
        response.receptable = res.receptable;
        // ↑だけではNG。閉店前に既に受付終了状態あり（満員）
        // 営業時間外か？
        response.opening = res.opening;

        // 待ち時間算出のためのデータ
        response.state = {
          reserves: response.list
        };
        // --- メニュー、設定
        res = await fetch(
          process.env.VUE_APP_API_SERVER + `base/${this.selectedShopId}`, {credentials: "include"}
        );
        res = await res.json();
        response.state.setting = res.setting;
        response.state.menus = res.menus;
        // --- 休憩情報
        res = await fetch(
          process.env.VUE_APP_API_SERVER + `resttimes/${this.selectedShopId}`, {credentials: "include"}
        );
        response.state.restSchedules = await res.json();
        
        // メッセージ
        res = await fetch(
          process.env.VUE_APP_API_SERVER + `recpmsg/${this.selectedShopId}`, {credentials: "include"}
        );
        this.messageData = await res.json();

        this.response = response;
        this.error = null;
      }
      catch(ex) {
        this.error = ex;
      }
      finally {
        setTimeout(() => {
          this.process = 0;
        }, 300)
      }
    },
    name(item) {
      return `${item.name} * *`
    },
    stat(item) {
      return item.ope_from ? "" : "待"
    },
  },
  filters: {
    formatTime(hhmm) {
      return `${Math.floor(hhmm/100)}:${hhmm.toString().substr(-2)}`
    }
  },
  created() {
    if (!this.selectedShopId) {
      this.$router.push('/');
      return;
    }
    
    this.loadData();

    const ms = this.$route.query.interval || 1000*60*5;
    // this.interval = setInterval(this.loadData, ms)
  },
  beforeDestroy() {
    clearInterval(this.interval)
  }
}
</script>

<style lang="scss" scoped>

$impactColor: #f8930ffa;

#stat-view {
  position: relative;
}
.flex {
  display : -webkit-box;     /* old Android */
  display : -webkit-flex;    /* Safari etc. */
  display : -ms-flexbox;     /* IE10        */
  display : flex;
}
#heading {
  position: relative;

  // レイアウト
  .-waiting {
    -webkit-flex-basis: 1;
    -ms-flex-basis    : 1;
    flex-basis        : 1;
    flex: 1;
  }
  .-info {
    // -webkit-flex-basis: 20%;
    // -ms-flex-basis    : 20%;
    // flex-basis        : 20%;
    .-tips {
      flex-direction: column;
    }
  }

  .-waiting {
    text-align: center;

    .-above, .-below {
      font-size: 60%;
    }
    .-count {
      font-size: 200%;
    }
    .-time {
      font-size: 200%;
    }
  }

  .-info {
    .-desc {
      font-size: 80%;
      > span {
        display: block;
        .-icon {
        }
      }
      .-ope {
        color: magenta;
      }
    }

    .-tips {
      justify-content: end;
      align-items: start;

      .-reload {
        font-size: 200%;
        color: moccasin;
        
        &:active {
          color:coral;
        }
      }
    }
  }
}

#shop-info {
  text-align: center;
  .shopname {
    font-size: 1.5em;
    padding-right: 1em;
  }
  #today {
    color: $impactColor;
  }
}

.-count-over {
  p {
    &:nth-child(1) {
      color:red;
      font-size: 200%;
    }
    &:nth-child(2) {
      color: darkslategray;
      font-size: 90%;
    }
  }
}

.-message {
  font-family: inherit;
  text-align: center;
  color: red;
  font-size: 100%;
  margin-bottom: 1em;
  overflow: hidden;
  white-space: -moz-pre-wrap; /* Mozilla */
  white-space: -pre-wrap;     /* Opera 4-6 */
  white-space: -o-pre-wrap;   /* Opera 7 */
  white-space: pre-wrap;      /* CSS3 */
  word-wrap: break-word;      /* IE 5.5+ */
}
h1.-message {
  font-size: 200%;
}
p.-desc {
  text-align: center;
}


table {
  z-index: 1;
  // border: 1px solid #ddd;
  width: 100%;
  text-align: left;

  thead {
    tr {
      background-color: $impactColor;
      th {
        padding: 10px 0;
        color: #fff;
        text-align: center;
      }
    }
  }

  tbody {
    tr:nth-of-type(2n) {
      background: #f5f5f5;
    }
    tr.-operating {
      color: magenta;
    }

    th {
      font-weight: bold;
    }

    td, th {
      // padding: 15px 0;
      height: 4em;
      text-align: center;
    }

    .-num {
      width: 3em;
    }
    .-time {
      width: 6em;
    }
    .-name {
      position: relative;
      .-text::after {
        content: "様";
        color: grey;
        font-size: 70%;
        margin-left: 1em;
      }
      .-reserve::after {
        content: "ご予約";
        position: absolute;
        top: 4px;
        font-size: 70%;
        color: red;
        opacity: .7;
      }
    }
    .-stat {
      width: 3em;
      .-icon {
        font-size: 200%;
      }
    }
  }
}

#closed, #unreceptable, #closed-day {
  margin: auto;
  text-align: center;

  .msg {
    font-size: 16pt !important;
    padding: 1em;
  }

  .img {
    display: inline-block;
    width: 70vw;
    height: 70vh;
    background: url(../assets/img/thanks.png) no-repeat center;
    background-size: contain;
  }
}

#loading {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  padding-top: 4em;
}


.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

/* 768px以上用（タブレット用）の記述 */
@media screen and (min-width: 480px) {
  #heading {
    .-info {
      .-desc {
        > span {
          display: inline;
        }
      }
    }
  }
}
</style>

<style lang="scss">
</style>